import { useCallback, useState } from "react";
import { ClientesQueryParams } from "core/features/cliente/typings";

export const defaultFiltroClientes: ClientesQueryParams = {
  search: "",
  orderBy: "nome",
  orderDirection: "ASC",
  documento: "",
};

function useFiltroClientes() {
  const [filtro, setFiltro] = useState<ClientesQueryParams>(
    defaultFiltroClientes
  );

  const onChangeFiltro = useCallback(
    (_filtro: Partial<ClientesQueryParams>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroClientes);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroClientes;
